// extracted by mini-css-extract-plugin
module.exports = {"root":"lDTYK7jJ","styledTabPanel":"LxElazJY","placeholder":"srb7HKNW","tabsContentWrapper":"oQ5flqkN"};